import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';
import { UploadExternalIcons } from './UploadExternalIcons';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function UploadExternalIconsButton({
    id,
    propertyId,
    parentLoadData
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <Fragment>
            <Button
                color="primary"
                outline
                className="ml-2"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                <FontAwesomeIcon icon={faPlus} />
                <span> </span>
                Use External Icon
            </Button>

            {isUpdating && (
                <UploadExternalIcons
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Add External Icon"
                    visible={isUpdating}
                    propertyId={propertyId}
                    parentLoadData={parentLoadData}

                />
            )}
        </Fragment>
    );
}